import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useManageMilestonesViewModel = () => {
  const [milestones, setMilestones] = useState([]);
  const stateManager = useComponentState();
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddOrderTemplateModal, setOpenAddOrderTemplateModal] =
    useState(false);
  const [orderTemplates, setOrderTemplates] = useState([]);

  const getMilestones = () => {
    stateManager.run(async () => {
      const response = await taskService.milestones.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setMilestones(response.data);
      }
    });
  };

  const getOrderTemplates = () => {
    stateManager.run(async () => {
      const response = await taskService.orderTemplates.getAll({
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setOrderTemplates(response.data);
      }
    });
  };

  const createMilestone = (data) => {
    return stateManager.run(async () =>
      taskService.milestones.create({
        data,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was created successfully.`,
          },
        },
      })
    );
  };

  const updateMilestone = (id, data) => {
    return stateManager.run(async () =>
      taskService.milestones.update({
        id,
        data,
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was updated successfully.`,
          },
        },
      })
    );
  };

  const deleteMilestone = (id, data) => {
    return stateManager.run(async () =>
      taskService.milestones.delete({
        id,
        data: { modifiedOn: data.modifiedOn },
        toastMessageConfig: {
          success: {
            text: ` ${data.name} was deleted successfully.`,
          },
        },
      })
    );
  };

  return {
    milestones,
    orderTemplates,
    stateManager,
    openAddModal,
    selectedItem,
    openDeleteModal,
    openAddOrderTemplateModal,
    getMilestones,
    getOrderTemplates,
    updateMilestone,
    deleteMilestone,
    createMilestone,
    setOpenAddModal,
    setSelectedItem,
    setOpenDeleteModal,
    setOpenAddOrderTemplateModal,
  };
};
